import { Component } from '@angular/core';
import { PermissionsEnum } from '../../../api/api-reference';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-analysis-report-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet, AngularSvgIconModule],
  templateUrl: './analysis-report-menu.component.html',
  styleUrl: './analysis-report-menu.component.scss'
})
export class AnalysisReportMenuComponent {
public PermissionsEnum = PermissionsEnum;

  constructor(private router: Router, public authService: AuthService) {}
  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
